import { Thunder } from "~/utils/generated/zeus"

export const useGql = defineStore("gql", () => {
	const config = useRuntimeConfig()
	const serverAddress = `${config.public.strapi.address}/graphql`
	const thunder = createThunder({ cache: "no-cache" })

	function createThunder(requestInit: RequestInit = {}) {
		return Thunder(async (query, variables) => {
			const response = await fetch(serverAddress, {
				body: JSON.stringify({ query, variables }),
				method: "POST",
				headers: makeHeader(),
				...requestInit,
			})

			const { data, errors, error } = await response.json()

			if (errors?.length) {
				console.error("GQL >>> ", query)
				throw new Error(errors[0].message)
			}

			if (error) {
				console.error("GQL >>> ", query)
				throw new Error(error.message)
			}

			return data
		})
	}

	function makeHeader() {
		const result = {
			"Content-Type": "application/json",
			"Authorization": `bearer ${config.public.strapi.key}`,
		}

		return result
	}

	return {
		query: thunder("query"),
		mutation: thunder("mutation"),
	}
})
